import { module as modujs } from "modujs";

export default class extends modujs {
	constructor(m) {
		super(m);

		this.events = {
			click: {
				link: "openSubmenu",
				back: "closeSubmenu",
				child: "openChildrenSubmenu",
			},
		};
	}

	init() {
		this.$submenus = this.$("submenu");
		this.$childrenSubmenus = this.$("children-submenu");
	}

	openSubmenu(e) {
		// Logic for the submenu
		let dataIndex = e.currentTarget.dataset.index;

		// Remove is-active class from all groups with a slight delay
		this.$submenus.forEach((submenu) => {
			submenu.classList.remove("is-active");
		});

		// Add is-active class to the group with matching data-index
		this.$submenus.forEach((submenu) => {
			if (submenu.dataset.index === dataIndex) {
				submenu.classList.add("is-active");
			}
		});
	}

	closeSubmenu(e) {
		// Check if any children submenu is active
		const isChildrenSubmenuActive = Array.from(this.$childrenSubmenus).some((submenu) => submenu.classList.contains("is-active"));

		if (isChildrenSubmenuActive) {
			// If children submenu is active, close it
			this.$childrenSubmenus.forEach((submenu) => {
				submenu.classList.remove("is-active");
			});
		} else {
			// Otherwise, close the regular submenu
			this.$submenus.forEach((submenu) => {
				submenu.classList.remove("is-active");
			});
		}
	}

	openChildrenSubmenu(e) {
		// Logic for the submenu
		let dataIndex = e.currentTarget.dataset.index;

		// Remove is-active class from all groups with a slight delay
		this.$childrenSubmenus.forEach((submenu) => {
			submenu.classList.remove("is-active");
		});

		// Add is-active class to the group with matching data-index
		this.$childrenSubmenus.forEach((submenu) => {
			if (submenu.dataset.index === dataIndex) {
				submenu.classList.add("is-active");
			}
		});
	}

	destroy() {}
}
